// extracted by mini-css-extract-plugin
export default {"reason_button":"ReportUserItem_reason_button__Jv8iM"};